import HubBuyTherapyGrantModule from './HubBuyTherapyGrantModule'

export default HubBuyTherapyGrantModule
